<template>
  <div
    :class="[
      'file-preview-progress',
      {
        'is-regular-variant': variant === FilePreviewVariantEnum.Regular,
        'is-inline-variant': variant === FilePreviewVariantEnum.Inline,
        'is-small-variant': variant === FilePreviewVariantEnum.Small,
        'is-proccessing': isProccessing,
      },
    ]"
  >
    <div
      class="file-preview-progress__line-bg"
      :style="{ width: progressbarWidth }"
    >
      <div
        class="file-preview-progress__line-fill"
        :style="{ width: fillWidth }"
      />
    </div>
    <span class="file-preview-progress__percent"> {{ percentStr }} </span>
  </div>
</template>

<script lang="ts" setup>
import { computed, PropType } from "vue";
import { FilePreviewVariantEnum } from "../../enums";

const props = defineProps({
  /**Вариант компонента */
  variant: {
    type: String as PropType<FilePreviewVariantEnum>,
    required: true,
  },
  /**Прогресс (в процентах) */
  progress: {
    type: Number,
    default: 0,
  },
  /**В обработке */
  isProccessing: {
    type: Boolean,
    default: false,
  },
  /**Ширина прогрессбара */
  progressbarWidth: {
    type: String,
    default: "auto",
  },
});

const percentStr = computed(() => `${Number(props.progress.toFixed(2))}%`);
/**Шинира заполненности */
const fillWidth = computed(() =>
  props.isProccessing ? "35%" : `${props.progress}%`
);
</script>

<style lang="scss" scoped>
@use "sass:map";

@import "tir-style-system/expose-variables";
@import "tir-style-system/expose-default-theme";
@import "tir-style-system/core/mixins";

.file-preview-progress {
  $self: ".file-preview-progress";

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--8, map.get($margins, "8"));

  &.is-proccessing {
    #{$self}__line-fill {
      animation: fillLine 1s infinite ease-out;
    }
  }

  &__line-bg {
    position: relative;
    height: var(--2, map.get($margins, "2"));
    border-radius: var(--2, map.get($margins, "2"));
    flex: 1;
    overflow: hidden;
  }
  &__line-fill {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    border-radius: var(--2, map.get($margins, "2"));
    transition: width 0.2s ease-in-out;
  }
  &__percent {
    font-size: var(--12, map.get($margins, "12"));
    font-weight: 400;
    line-height: var(--16, map.get($margins, "16"));
  }

  &.is-inline-variant #{$self} {
    &__line-bg {
      background-color: rgba(74, 0, 195, 0.102);
    }
    &__line-fill {
      background-color: #5202b8;
    }
    &__percent {
      color: #5202b8;
    }
  }
  &.is-regular-variant #{$self} {
    &__line-bg {
      background-color: var(--neutral-10, #eaeaeb);
    }
    &__line-fill {
      background-color: var(--accent-accent, #34538d);
    }
    &__percent {
      color: var(--text-qunternery, #bfc0c3);
    }
  }

  &.is-small-variant #{$self} {
    &__line-bg {
      background-color: var(--neutral-10, #eaeaeb);
    }
    &__line-fill {
      background-color: var(--accent-accent, #34538d);
    }
    &__percent {
      color: var(--bg-base, #fff);
    }
  }
}

@keyframes fillLine {
  0% {
    transform: translateX(-100%);
    left: 0;
  }
  100% {
    transform: translateX(286%);
  }
}
</style>
